import React, { ReactElement } from 'react';
import Table from 'components/CustomTable/CustomTable';
import TableHeader from 'components/TableHeader/TableHeader';
import Add from '@material-ui/icons/Add';

import { translate } from 'components/Translation';
import { HeadingMBold } from 'components/Typography/Typography';

interface IButton {
	text: ReactElement | string;
	onClick: (event: any) => void;
	disabled?: boolean;
	action: string;
	id?: string;
}

interface ISpecialUsersTableProps {
	header: string;
	columns: any[];
	data: any[];
	selectedIndexes: number[];
	setSelectedIndexes: (index: number[]) => void;
	searchInputValue?: string;
	setSearchInputValue?: (value: string) => void;
	button: IButton;
	exportToXLS?: () => void;
	deleteItems: () => void;
	text?: string;
	deleteItemsAction: string;
}

const SpecialUsersTable = (props: ISpecialUsersTableProps) => {
	const {
		header,
		columns,
		data,
		selectedIndexes,
		setSelectedIndexes,
		searchInputValue,
		setSearchInputValue,
		button,
		exportToXLS,
		deleteItems,
		text,
		deleteItemsAction,
	} = props;

	return (
		<>
			<HeadingMBold color="secondary-light">{header}</HeadingMBold>
			<TableHeader
				setSearchInputValue={setSearchInputValue}
				exportToXLS={exportToXLS}
				searchInputValue={searchInputValue}
				buttons={{
					text: (
						<>
							<Add /> {button.text}
						</>
					),
					onClick: button.onClick,
					action: button.action,
					buttonProps: {
						withIcon: true,
						disabled: button.disabled,
					},
					id: button.id,
				}}
				text={text}
			/>
			<Table
				withCheckbox
				withHeader
				total={data.length}
				onSelect={(value) => setSelectedIndexes(value)}
				selected={selectedIndexes}
				selectPanel={{
					selectedElements: selectedIndexes.length,
					deleteItems: () => deleteItems(),
					confirmationDialogTitle: translate('department.details.users.table.delete.elements'),
					confirmationDialogBody: translate('department.details.users.table.are.you.sure'),
					deleteItemsAction: deleteItemsAction,
					downloadMenuItems: [
						{
							name: 'XSLX',
							onClick: () => !!exportToXLS && exportToXLS(),
						},
					],
				}}
				tableProps={{
					data: data,
					columns: columns,
					defaultPageSize: 10,
				}}
			/>
		</>
	);
};

export default SpecialUsersTable;
